var React = require('react');

function LinkArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.414 1.414l7.779 7.78-7.779 7.78","fill":"none","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2"}));
}

LinkArrow.defaultProps = {"width":"10.192","height":"18.389"};

module.exports = LinkArrow;

LinkArrow.default = LinkArrow;
